module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/node-libs-browser/~/isarray/index.js
 ** module id = 1664
 ** module chunks = 0
 **/